import React, { useEffect, useState } from 'react';
import classes from "./styles/jobCard.module.css";
// import { formatDate2 } from '../../services/DateFormats';

import breifCaseIcon from "../../assets/svg/briefcase-outline.svg";
import locationIcon from "../../assets/svg/location-outline.svg";
// import clockIcon from "../../assets/svg/time-outline.svg";
import { useNavigate } from 'react-router-dom';

const JobCard = ({
  title,
  summary,
  company,
  id,
  datePosted,
  apiType,
  onClick ,
  location,
  selectedJobId
}) => {

  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 990);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = () => {
    if (isMobile) {
      navigate(`/job-description-${apiType}/${id}`);
    } else {
      onClick();
    }
  };

  return (
    <div>
        <div className={selectedJobId ? classes.selectedCardCon : classes.cardCon} onClick={handleClick}>
          {apiType === "self" && <img className={classes.star} src='https://cdn-icons-png.flaticon.com/128/2107/2107957.png' alt='star'/>}
          <h2 className={classes.jobtitle}>{title}</h2>
          <div className={classes.companyCon}>
            <p><img src={breifCaseIcon} alt='jobs-company-icon'/><span>{company}</span></p>
            <p><img src={locationIcon} alt='location-icon'/><span>{location}</span></p>
            {/* {datePosted && <p><img src={clockIcon} alt='clock-icon'/><span>{formatDate2(datePosted)}</span></p>} */}
          </div>
          {/* <p className={classes.summary} dangerouslySetInnerHTML={{ __html: summary.replace(/<br\s*\/?>/gi, '')}} /> */}
        </div>
    </div>
  )
}

export default JobCard